<template>
	<div class="tags">
		<slot></slot>
	</div>
</template>

<script>
export default {}
</script>

<style scoped>
.tags {
	display: flex;
	gap: 8px;
	flex-direction: column;
}
@media (min-width: 768px) {
	.tags {
		gap: 12px;
	}
}
</style>
